import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=246aa2ca"
import script from "./NoticeEdit.vue?vue&type=script&lang=js"
export * from "./NoticeEdit.vue?vue&type=script&lang=js"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=246aa2ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports